module.exports = __webpack_public_path__ + "img/category-naibu.3d655ad0.svg";